module.exports = __webpack_public_path__ + "static/media/OFFICE.14452cbd.jpg";